export default __webpack_public_path__ + "static/media/updated-ISCO.46aed396.pdf";